import type { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import * as companyApi from '@/services/companyService';
import * as actions from './companyActions';

export function* getCompaniesSaga(): SagaIterator {
	try {
		const {
			data: { data }
		} = yield call(companyApi.getCompanies);
		yield put(actions.getCompaniesSuccess(data));
	} catch (error) {
		yield put(actions.getCompaniesFailure(error));
	}
}

export function* createCompanySaga(payload: any): SagaIterator {
	try {
		const { name } = payload.payload;
		const { marketCoordinates } = payload.payload;
		const { companyHsId } = payload.payload;

		const { data } = yield call(() =>
			companyApi.createCompany({ name, marketCoordinates, companyHsId })
		);

		if (data.data && data.data.message === 'Company created successfully') {
			yield put(actions.createCompanySuccess(data));
		} else {
			const errorMessage =
				typeof data.data === 'string' ? data.data : data.data.message;
			throw new Error(errorMessage);
		}
	} catch (error) {
		yield put(actions.createCompanyFailure(error));
	}
}

export function* updateCompanyHsId(payload: any): SagaIterator {
	try {
		const { companyId, companyHsId } = payload.payload;
		const { data } = yield call(() =>
			companyApi.updateCompanyHsId({ companyId, companyHsId })
		);
		if (data.data && data.data.message === 'Company updated successfully') {
			yield put(actions.updateCompanyHsIdSuccess(data));
		} else {
			const errorMessage =
				typeof data.data === 'string' ? data.data : data.data.message;
			throw new Error(errorMessage);
		}
	} catch (error) {
		yield put(actions.updateCompanyHsIdFailure(error));
	}
}

export function* getCompanyHubspotId(payload: any): SagaIterator {
	try {
		const { companyId } = payload.payload;
		const { data } = yield call(() =>
			companyApi.getCompanyHubspotId({ companyId })
		);
		const companyHsId = data?.data?.companyHsId;

		yield put(actions.getCompanyHubspotIdSuccess(companyHsId));
	} catch (error) {
		yield put(actions.getCompanyHubspotIdFailure(error));
	}
}

export function* updateCompanySaga(payload: any): SagaIterator {
	try {
		const { name } = payload.payload;
		const { marketCoordinates } = payload.payload;
		const { companyHsId } = payload.payload;
		const { data } = yield call(() =>
			companyApi.updateCompany({ name, marketCoordinates, companyHsId })
		);

		if (data.data && data.data.message === 'Company updated successfully') {
			yield put(actions.updateCompanySuccess(data));
		} else {
			const errorMessage =
				typeof data.data === 'string' ? data.data : data.data.message;
			throw new Error(errorMessage);
		}
	} catch (error) {
		yield put(actions.updateCompanyFailure(error));
	}
}

export function* searchHubspotCompanySaga(action: any): SagaIterator {
	try {
		const { companyName } = action.payload;
		const { data } = yield call(() =>
			companyApi.searchHubspotCompany({ companyName })
		);
		yield put(actions.searchHubspotCompanySuccess(data.data));
	} catch (error) {
		yield put(actions.searchHubspotCompanyFailure(error));
	}
}
